<header class="homepage" id="header" [ngStyle]="{'background-image': 'url(\'./assets/'+homeImage+'\')'}"></header>
<app-text *ngIf="localeId==='eu'" slug='aurkezpena-industria-paisaia'></app-text>
<app-text *ngIf="localeId==='es'" slug='presentacion-paisaje-industrial'></app-text>
<app-section [pages]=pages></app-section>
